/**
 * @author lifei & gll
 * 模块说明：用户中心-所有用户管理
 */
import { Service } from '@/tools'

export class UserService<T extends TUser.User> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.User}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  private upload2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.User}`, data?: TCommon.Json, toast?: string) {
    return this.upload(url, data, toast)
  }

  /**
   * 功能：用户中心/所有用户管理/分批查询用户列表
   * /api/user/user/v1/page
   */
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  /**
   * 功能：用户中心/所有用户管理/重置密码
   * /api/user/user/v1/resetPassword
   */
  resetPassword = <K extends T['ApiResetPassword']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiResetPassword', data)

  /**
   * 功能：用户中心/所有用户管理/查看用户详情
   * /api/user/user/v1/detail
   */
  detail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDetail', data)

  /**
   * 功能：用户中心/所有用户管理/编辑用户
   * /api/user/user/v1/update
   */
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)

  /**
   * 功能：用户中心/所有用户管理/新增用户
   * /api/user/user/v1/add
   */
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)

  /**
   * 功能：用户中心/所有用户管理/修改个人密码
   * /api/user/user/v1/updatePassword
   */
  updatePassword = <K extends T['ApiUpdatePassword']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdatePassword', data)

  /**
   * 功能：用户中心/所有用户管理/查看用户个人信息
   *  /api/user/user/v1/personalInfo
   */
  personalInfo = <K extends T['ApiPersonalInfo']>(): Promise<K['res']> => this.post2('v1/ApiPersonalInfo')

  /**
   * 功能：导入用户
   *  /api/user/user/v1/userImport
   */
  userImport = <K extends T['ApiUserImport']>(data: K['req']): Promise<K['res']> => this.upload2('v1/ApiUserImport', data)

  /**
   * 功能：导出用户
   *  /api/user/user/v1/userExport
   */
  userExport = <K extends T['ApiUserExport']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUserExport', data, 'blob')

  /**
   * 功能：查询所有用户列表
   *  /api/user/user/v1/allUsers
   */
  allUsers = <K extends T['ApiAllUsers']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAllUsers', data)
}
